// src/pages/Privacy.jsx

const Privacy = () => {
    return (
        <div className="max-w-4xl mx-auto px-6 py-12 text-[#144E73]">
            <h1 className="text-3xl md:text-4xl font-bold mb-6">Privacy Policy</h1>
            <p className="text-sm md:text-base leading-relaxed space-y-4">
                <p>We value your privacy and are committed to protecting your personal data in accordance with the Protection of Personal Information Act (POPIA) of South Africa.</p>

                <p>This Privacy Policy describes how Benecke Group collects, uses, and protects the personal information you provide when using our website or services.</p>

                <h2 className="font-semibold mt-6">1. What We Collect</h2>
                <ul className="list-disc pl-6 mt-2">
                    <li>Full name</li>
                    <li>Email address</li>
                    <li>Phone number</li>
                    <li>Booking and rental history</li>
                    <li>Website usage data (cookies, IP address)</li>
                </ul>

                <h2 className="font-semibold mt-6">2. How We Use It</h2>
                <ul className="list-disc pl-6 mt-2">
                    <li>To confirm bookings or respond to inquiries</li>
                    <li>To send important updates or promotions (if opted in)</li>
                    <li>To improve our website and services</li>
                </ul>

                <h2 className="font-semibold mt-6">3. Sharing of Information</h2>
                <p>We do not sell or rent your personal information. Data may be shared with trusted partners only where necessary to fulfill services (e.g., secure payment processing).</p>

                <h2 className="font-semibold mt-6">4. Data Retention</h2>
                <p>Your information will be stored securely and only for as long as necessary to fulfill the purpose it was collected for.</p>

                <h2 className="font-semibold mt-6">5. Your Rights</h2>
                <ul className="list-disc pl-6 mt-2">
                    <li>Request access to your personal data</li>
                    <li>Request corrections or deletions</li>
                    <li>Withdraw consent at any time</li>
                </ul>

                <h2 className="font-semibold mt-6">6. Contact Us</h2>
                <p>
                    For privacy-related questions or requests, please contact us at:{" "}
                    <a href="mailto:mrd@wol.co.za" className="underline text-blue-600">mrd@wol.co.za</a>
                </p>
                <div className="mt-8">
                    <a
                        href="/Benecke-Privacy-Policy.pdf"
                        download
                        className="inline-block bg-[#F29E38] text-[#023059] px-6 py-2 rounded-full font-semibold shadow hover:bg-opacity-90 transition"
                    >
                        Download PDF
                    </a>
                </div>

            </p>
        </div>
    );
};

export default Privacy;
